export default "__VITE_ASSET__mEc_RQFx__"